import store from '@/store'
import questionnaireApi from '@/api/module/questionnaire'

const baldWechatShareConfig = {
  title: '秃头风险计算器',
  desc: '发比金坚？还是秃如其来？快来测测！',
  imgUrl: 'https://frontend-1251027788.cos.ap-guangzhou.myqcloud.com/service_component/health/questionnaire/bald/wechat_share.png',
  route: 'questionnaire/bald'
}

const questionnaire = [
  {
    path: '/questionnaire/pylori',
    component: () => import(/* webpackChunkName: "questionnaire-pylori" */ '@/pages/questionnaire/pylori/index.vue'),
    children: [
      {
        name: 'pyloriHome',
        path: '/',
        component: () => import(/* webpackChunkName: "questionnaire-pylori-home" */ '@/pages/questionnaire/pylori/home.vue'),
        meta: {
          title: '健康自测',
          login: false,
          titleBar: {
            title: '健康自测',
            hasMenu: true
          }
        },
        beforeEnter: (to, from, next) => {
          const getTestRecord = () => {
            questionnaireApi.getUserTestRecord().then(res => {
              if (res.code === 200 && res.data.data.flag) {
                // flag 为true，做过测试，跳转测试结果页面
                next({ path: '/questionnaire/pylori/report' })
              } else {
                // 授权来的，直接开始测试
                if (to.query.from_auth) {
                  next({ path: '/questionnaire/pylori/test' })
                } else {
                  next()
                }
              }
            })
          }
          console.log('store user信息', store.state?.user?.authStatus)
          if (to.query.retest) {
            // 重新测试不能跳转报告结果页
            next()
          } else if (store.state?.user?.authStatus) {
            getTestRecord(next)
          } else if (to.query.from_auth) {
            // 授权之后跳转回来的
            getTestRecord(next)
          } else {
            next()
          }
        }
      },
      {
        name: 'pyloriTest',
        path: 'test',
        component: () => import(/* webpackChunkName: "questionnaire-pylori-test" */ '@/pages/questionnaire/pylori/test.vue'),
        meta: {
          title: '健康测评',
          login: true,
          titleBar: {
            title: '健康测评',
            hasMenu: true
          }
        }
      },
      {
        name: 'pyloriReport',
        path: 'report',
        component: () => import(/* webpackChunkName: "questionnaire-pylori-report" */ '@/pages/questionnaire/pylori/report.vue'),
        meta: {
          title: '测评报告',
          login: true,
          titleBar: {
            title: '测评报告',
            hasMenu: true
          }
        }
      }
    ]
  },
  {
    path: '/questionnaire/bald',
    component: () => import(/* webpackChunkName: "questionnaire-bald" */ '@/pages/questionnaire/bald/index.vue'),
    children: [
      {
        name: 'baldHome',
        path: '/',
        component: () => import(/* webpackChunkName: "questionnaire-bald-home" */ '@/pages/questionnaire/bald/home.vue'),
        meta: {
          title: '秃头风险计算器',
          hiddenWeChatShare: true
          // wechatShareConfig: baldWechatShareConfig
        }
      },
      {
        name: 'baldTest',
        path: 'test',
        component: () => import(/* webpackChunkName: "questionnaire-bald-test" */ '@/pages/questionnaire/bald/test.vue'),
        meta: {
          title: '秃头风险计算器',
          hiddenWeChatShare: true
          // wechatShareConfig: baldWechatShareConfig
        }
      },
      {
        name: 'baldReport',
        path: 'report',
        component: () => import(/* webpackChunkName: "questionnaire-bald-report" */ '@/pages/questionnaire/bald/report.vue'),
        beforeEnter(to, from, next) {
          if (!sessionStorage.getItem('BALD_REPORT_RESULT')) {
            next({ name: 'baldHome' })
          } else {
            next()
          }
        },
        meta: {
          title: '秃头风险计算器',
          hiddenWeChatShare: true
          // wechatShareConfig: baldWechatShareConfig
        }
      }
    ]
  }
]

export default questionnaire
